export const drawerWidth = 260;
export const drawerClosedWidth = 50;
export const addEditDrawerWidth = 350;

export const actionColumns = ['actions'];
export const pageSizes = [10, 20, 50];
export const filteringStateColumnExtensions = [
  { columnName: 'actions', filteringEnabled: false },
];

export const stockAvailability = { 'available': 'AVAILABLE', 'unavailable': 'UNAVAILABLE' };
export const transportOrderState = { 'moving': 'MOVING', 'done': 'DONE', 'stopped': 'STOPPED' };

//number of colums on the orders overview page => 12/12 => 1 colum , 6/12 => 2, 4/12 => 3 , 3/12 => 4, ...
export const xsValue = 12 // 1 colum

//Machine Types
export const pump = 1;

//MachineIds
export const machineIds = { 'PREWELDING': 1, 'AUTOWELDING': 2, 'MANUALWELDING': 3, 'PAINTING': 4 }

//Quality check statusses
export const qualityCheckStatusses = { 'POSITIVE': 1, 'NOT_EXECUTED': 2, 'NEGATIVE': 3 }

//Workflow step statusses
export const workflowStepStatusses = { 'Planned': 1, 'Started': 2, 'Paused': 3, 'Done': 4 }



//Machine states
export const machineStates = { 'PRODUCTION': 'Production', 'STANDBY': 'Standby', 'PLANNEDSTOP': 'Planned Stop', 'UNPLANNEDSTOP': 'Unplanned Stop' }

// Machine settings
export const machineSettings = { 'PUMPFOAMY': 'pump foamy', 'PACKAGING': 'packaging', 'TANKVOLUME': 'volume', 'TANKPRODUCT': 'product' }

// Machine types
export const machineTypes = { 'PICKING': 1, 'MANUALWELDING': 2, 'CHANGEOVER': 3, 'PREPPINGSTATION': 4, 'WELDINGROBOT': 5, 'PAINTING': 6, 'PACKAGING': 7, 'QUALITYASSURANCE': 8, "OUTBOUNDLOGISTICS": 9 }

//Default login authentication error message
export const defaultAuthenticationErrorMessage = "The username and password do not match"

//Material parameters
export const uomKg = "Kg";
export const uomPieces = "Stuks";
export const uomGr = "G";
export const uomM = "M";
export const uomMm = "MM";
export const carrierTypePallet = 2;

//Product type
export const productTypePackaging = 'Packaging'
export const productTypeAdditive = 'Additive'
export const productTypeRawMaterial = 'RawMaterial'
export const productTypeTapeFoil = 'TapeFoil'
export const productTypeUnknown = 'Unknown'
export const productTypeMaterial = "Material";
export const productTypeEndMaterial = "EndMaterial";


//Hazard symbool namen
export const healthhazard = "HEALTHHAZARD"
export const flammable = "FLAMMABLE"
export const oxidising = "OXIDISING"
export const environmenthazard = "ENVIRONMENTHAZARD"
export const serioushealthhazard = "SERIOUSHEALTHHAZARD"
export const corrosive = "CORROSIVE"


// DataTypes
export const bool = 1;
export const integer = 2;
export const decimal = 3;
export const string = 4;

// Machine reasons
export const Unknown = 0;
export const Maintenance = 1;
export const Packaging = 2;
export const Rupture = 3;
export const Emergency = 4;
export const Labels = 5;

// Notification types
export const notificationTypes = { 'PROBLEM': 1, 'CLEANING': 2, 'MACHINESTART': 3, "MACHINESTOP": 4, "MACHINESTANDBY": 5 }

// SystemParameters
export const systemParameters = { 'Silos': 1, 'ExceedingOrderProgressColorFactors': 2, 'NumberOfMachinesSimultanious': 4, 'MaterialReasonForRequest': 8, 'ReworkWorkstations': 9 }

// SystemMessages
export const systemMessages = { 'PROBLEM_DETECTED_RUPTURE': 1, 'PROBLEM_DETECTED_EMERGENCY_STOP': 2, 'PROBLEM_DETECTED_PACKAGING': 3, 'PROBLEM_DETECTED_CLEANING_REQUESTED': 4, 'PROBLEM_DETECTED_LABELS': 5, 'PROBLEM_DETECTED_CUSTOM_MESSAGE': 6 }

// timeout names
export const timeouts = { 'LOGOUTTIMEOUT': "logoutTimeout", 'SESSIONTIMEOUTPOPUP': "sessionTimeoutPopup" }

// Languages
export const languages = { 'DUTCH': 1, 'ENGLISH': 3 }

// Roles
export const roles = { 'ADMINISTRATOR': 1, 'OPERATOR': 2, 'PLOEGCHEF': 3, 'QA': 4 }

// Permissions
export const permissions = { 'ALLOW_ADD_REMOVE_MATERIAL': 1, 'AllowBookOrder': 2, 'AllowQA': 3, 'AllowPicking': 4 }

// Competences
export const competences = { 'WELDING': 1, 'PAINTING': 2, 'PICKING': 3 }

// booking results
export const bookingResults = { 'SUCCESS': 1, 'WRONGBARCODE': 2, 'ALREADYBOOKED': 3, 'NEEDQUANTITY': 4, 'UNKNOWNCARTNUMBER': 5, 'MATERIALNOTASSIGNED': 6, 'NORESULT': 7 }

export const assignResults = { 'SUCCESS': 1, 'PREVIOUSSTEPUNCOMPLETE': 2, 'WRONGBARCODE': 3, 'NOBOMINONCART': 4, 'ALREADYBOOKED': 5, 'ALREADYASSIGNED': 6 }

// product types
export const productTypes = { 'MATERIAL': 'Material', 'PANEL': 'Panel' }

// Quality samples
export const dimensionQualityChecks = { 'LENGTEL': 'Lengte L', 'LENGTER': 'Lengte R', 'BREEDTE': 'Breedte', 'DIKTE': 'Dikte', 'GEWICHT': 'Gewicht' }

// Application
export const applicationIds = { 'SMARTPRODUCTION': 1, 'SMARTPRODUCTIVITY': 2, 'SMARTPRODUCTION/SMARTPRODUCTIVITY': 3 }

export const stockSearchTypes = { 'PALLET': 1, 'LOCATION': 2, 'ORDER': 3, 'PRODUCT': 4 }

// ProductionOrderLineTypes
export const productionOrderLineTypes = { 'Production': 1, 'Packaging': 2, 'Rework': 3 }

// MediaTypes
export const mediaTypes = { 'Image': 1, 'SharePointUrl': 2, 'PDF': 3 }






